import React from "react";

import logo from "../../Assets/Logo/Logo.png";
import GetTheApp from "../Inputs/GetTheApp";

const Header = () => {
  return (
    <nav
      id="header"
      className="sticky w-[97%] lg:max-w-[90%] rounded-[18px] md:rounded-[20px] lg:flex lg:items-center lg:justify-center mx-auto lg:h-[95px]  z-50 top-[calc(var(--banner-h,0px)_+_12px)] bg-[#FFF] "
    >
      <div className="w-full px-4 sm:p-4  mx-auto flex items-center justify-between ">
        <div className=" py-[10px] sm:py-[16px]  flex cursor-pointer gap-4 items-center">
          <a href="/" className=" pt-[2px] pb-1 px-2">
            <img src={logo} alt="Halvest" className=" w-[110px] sm:w-[133.33px]" />
          </a>
        </div>

        <div className="px-2">
          <GetTheApp compact location="Header" />
        </div>
      </div>
    </nav>
  );
};

export default Header;
